module.exports = __webpack_public_path__ + "static/media/Eye_Black_on.77691e0c.svg";